import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/zip';
import { NumberFormat, DateFormat, GridColumn, CrawfordSnackbarService, CrawfordSpinnerService, ITabComponent } from 'crawford-shell';

import { global } from '../../app.settings';

import { FormBuilder } from '@angular/forms';
import { ClaimService } from '../claim.service';
import { ClaimFeesDisbursementsSummary } from '../model/claim-fees-disbursements-summary.model';
import { ClaimFee } from '../model/claim-fee.model';
import { ClaimDisbursement } from '../model/claim-disbursement.model';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-claim-fees-disbursements',
  templateUrl: './claim-fees-disbursements.component.html',
  styleUrls: ['./claim-fees-disbursements.component.scss']
})
export class ClaimFeesDisbursementsComponent implements OnInit, ITabComponent {

  @Input() public crawfordRef: string;
  @Input() public claimOpen: boolean;
  @Input() public source: string;

  private dataLoaded = false;
  public feesDisbursementsSummaryForm: FormGroup;
  public feesDisbursementsSummary: ClaimFeesDisbursementsSummary;
  public feesData: ClaimFee[];
  public disbursementsData: ClaimDisbursement[];

  public df: DateFormat = {
    type: 'date',
    format: 'dd/MM/yyyy'
  };

  public cf: NumberFormat = {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    currency: 'gbp',
    format: '£#,#.##'
  };

  public displayColumns: GridColumn[] = [
    new GridColumn('type', 'Type'),
    new GridColumn('value', 'Value', {type: 'number', format: this.cf}),
    new GridColumn('date', 'Date', { type: 'date', format: this.df}),
    new GridColumn('invoiceDate', 'Invoice Date', { type: 'date', format: this.df})
  ];

  constructor(private formBuilder: FormBuilder,
    private claimService: ClaimService,
    private snackbarService: CrawfordSnackbarService,
    private spinnerService: CrawfordSpinnerService,
  private activatedRoute: ActivatedRoute) {
  }

  ngOnInit() {
    this.createFeesDisbursementsForm();
  }

  private createFeesDisbursementsForm() {
    this.feesDisbursementsSummaryForm = this.formBuilder.group({
      totalInterimFees: new FormControl(),
      totalFeesAndDisbursements: new FormControl(),
      invoicedDisbursements: new FormControl(),
      vatOnTotalFees: new FormControl(),
      vatOnInterimFees: new FormControl(),
      unInvoicedDisbursements: new FormControl()
    });
  }

  private setFormValues() {
    const currencyFormat = new Intl.NumberFormat('en-gb', { style: 'currency', currency: 'GBP' });
    this.feesDisbursementsSummaryForm.reset({
      totalInterimFees: currencyFormat.format(this.feesDisbursementsSummary.totalInterimFees),
      totalFeesAndDisbursements: currencyFormat.format(this.feesDisbursementsSummary.totalFeesAndDisbursements),
      invoicedDisbursements: currencyFormat.format(this.feesDisbursementsSummary.invoicedDisbursements),
      vatOnTotalFees: currencyFormat.format(this.feesDisbursementsSummary.vatOnTotalFees),
      vatOnInterimFees: currencyFormat.format(this.feesDisbursementsSummary.vatOnInterimFees),
      unInvoicedDisbursements: currencyFormat.format(this.feesDisbursementsSummary.unInvoicedDisbursements)

    });
  }

  loadData(): void {
    if (!this.dataLoaded) {
      this.spinnerService.show('claimFeesDisbursementsSpinner');
      if (this.crawfordRef) {
        Observable.zip(
          this.claimService.getFeesDisbursementsSummary(this.crawfordRef, this.source),
          this.claimService.getClaimFees(this.crawfordRef, this.source),
          this.claimService.getClaimDisbursements(this.crawfordRef, this.source)
        ).subscribe(
          (feesDisbursementsData) => {
            this.loadFeesDisbursementsSummary(feesDisbursementsData[0]);
            this.loadFees(feesDisbursementsData[1]);
            this.loadDisbursements(feesDisbursementsData[2]);
            this.dataLoaded = true;
            this.spinnerService.hide('claimFeesDisbursementsSpinner');
          },
          error => {
            this.spinnerService.hide('claimFeesDisbursementsSpinner');
          }
        );
      } else {
        this.spinnerService.hide('claimFeesDisbursementsSpinner');
        this.snackbarService.displayErrorMessage('No Crawford Reference provided to obtain Fees and Disbursements');
      }
    }
  }

  private loadFeesDisbursementsSummary(summary): void {
    if (summary) {
      this.feesDisbursementsSummary = summary;
      this.setFormValues();
      this.feesDisbursementsSummaryForm.disable();
    } else {
      this.snackbarService.displayErrorMessage('No Reserves and Payments Summary was found for Claim: ' + this.crawfordRef);
    }
  }

  private loadFees(fees): void {
    if (fees) {
      this.feesData = fees;
    } else {
      this.feesData = [];
    }
  }

  private loadDisbursements(disbursements): void {
    if (disbursements) {
      this.disbursementsData = disbursements;
    } else {
      this.disbursementsData = [];
    }
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/UI/src/app/claim/claim-fees-disbursements/claim-fees-disbursements.component.ts